export default __webpack_public_path__ + "static/media/hamburger.54f3a59a.svg";